import React from "react";

export const Privacy = ({ ui }) => {
  return (
    <div id="privacy" className="text-center privacy-section">
      <div className="container">
        <div className="section-title">
          <h2>{ui?.title}</h2>
        </div>

        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <p className="privacy-copy">
              <strong>{ui?.paragraph1Strong}</strong> {ui?.paragraph1Rest}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
